import React from 'react'
import { ModulePanel, ModuleHeader, ModuleBody, ModuleFooter } from 'containers/purchase/modules/module_panel'
import TicketTypesList from 'containers/purchase/modules/ticket_types_module/ticket_types_list'
import { useTranslation } from 'react-i18next'

const TransferVehicleModule = (props) => {
  const { config, machine, status, type = 'event_ticket', resSize } = props
  const { t, i18n } = useTranslation()
  const [current, send] = machine

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() => (status === 'completed' ? send('REOPEN_TRANSFERVEHICLESTEP') : null)}
      >
        <span>
          <i className="fa fa-car me-2" aria-hidden="true"></i>
          {i18n.t('transfer_vehicle_module.title')}
        </span>
      </ModuleHeader>
      <ModuleBody status={status} className={' '}>
        awfwaf
      </ModuleBody>
      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default TransferVehicleModule
